import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { QSpinner, QText } from '@qualio/ui-components';
import { SeverityType } from '../../../types/eventMetadata';
import { EMPTY_FILTER_VALUE } from '../../../types/qualityEvent';

const ActiveSeverityFilter = ({
  value,
  severitiesMap,
}: {
  value: unknown;
  severitiesMap: Record<string, SeverityType>;
}): ReactElement => {
  const { t } = useTranslation();
  if (value === EMPTY_FILTER_VALUE) {
    return <QText as="span">{t('common.labels.emptySeverities')}</QText>;
  }
  const id = value as number;
  const severity = severitiesMap[id];
  if (severity) {
    return <QText as="span">{severity.name}</QText>;
  }
  return <QSpinner size="sm" />;
};

export default ActiveSeverityFilter;
